export default "__VITE_ASSET__798c5f8b__"